import script from "./NewGivingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./NewGivingForm.vue?vue&type=script&setup=true&lang=js"

import "./NewGivingForm.vue?vue&type=style&index=0&id=5382e552&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5382e552"]])

export default __exports__